<!-- 无活动数据分析报告 -->
<template>
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box">
        <div class="header_titles">
          <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
          <input id="completeNum" v-model="completeNum" v-show="false" />
          <h1>职业教育“{{ header.zykName }}”专业教学资源库({{ header.zykNum }})</h1>
          <h1 style="margin-top: 15px">无活动数据分析{{ jd == 1 ? "季度" : "" }}报告</h1>
          <div class="number_time">
            <div>
              <span>主持单位：{{ header.allHostUnit }}</span>
              <span>数据分析时间：{{ analysisTime }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="division">1. 建设院校师生实名情况</div>
        <h4>1.1 建设院校师生实名情况</h4>
        <p>
          当前该资源库的教师总数{{ getUtils_Fun(teacherStudent.teacher) }}人，学生总数{{
            getUtils_Fun(teacherStudent.student)
          }}人。其中建设院校教师{{ getUtils_Fun(teacherStudent.buildSchoolTeacherNum) }}人，学生{{
            getUtils_Fun(teacherStudent.buildSchoolStudentNum)
          }}人；已实名教师{{ getUtils_Fun(teacherStudent.realNameTeacher) }}人，已实名学生{{
            getUtils_Fun(teacherStudent.realNameStudent)
          }}人。已实名教师、学生用户占比具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <meterChart
            :datas="
              getPercent(teacherStudent.realNameTeacher, teacherStudent.buildSchoolTeacherNum)
            "
            :circleRadius="'80%'"
            :colorList="meterColorList"
          />
        </div>
        <div class="chart_name">图1 建设院校已实名教师占比</div>
        <div class="standards_content echartsHeight">
          <meterChart
            :datas="
              getPercent(teacherStudent.realNameStudent, teacherStudent.buildSchoolStudentNum)
            "
            :circleRadius="'80%'"
            :colorList="meterColorList"
          />
        </div>
        <div class="chart_name">图2 建设院校已实名学生占比</div>
        <h4 class="m-top150">1.2 近三年建设院校学生新增与实名情况</h4>
        <p>
          该资源库建设院校近三年新增学生{{ getUtils_Fun(threeYearStudent.total) }}人，已实名学生{{
            getUtils_Fun(threeYearStudent.realTotal)
          }}人。具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'lastcoursesMonthChart'"
            :legendList="['新增学生', '实名学生']"
            :datas="threeYearStudent.dataList"
            :transverseData="threeYearStudent.year"
            :colorList="barColorList"
            :colorName="1"
            :innerText="'单位：人'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          ></vcolumnarChart>
        </div>
        <div class="chart_name">图3 近三年建设院校学生新增与实名情况</div>
      </div>
      <div class="chart_box page-box">
        <div class="division">2. 建设院校实名师生无活动情况</div>
        <h4>2.1 建设院校实名师生无活动情况</h4>
        <p>
          该资源库建设院校实名无活动用户数{{
            getUtils_Fun(noActiveUser.noActivityBuildSchoolUser)
          }}人，其中无活动教师{{ getUtils_Fun(noActiveUser.noActivityTeacher) }}人，无活动学生{{
            getUtils_Fun(noActiveUser.noActivityStudent)
          }}人。具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <meterChart
            :datas="getPercent(noActiveUser.noActivityTeacher, noActiveUser.realNameTeacher)"
            :circleRadius="'80%'"
            :colorList="meterColorList"
          />
        </div>
        <div class="chart_name">图4 实名教师无活动占比</div>
        <div class="standards_content echartsHeight">
          <meterChart
            :datas="getPercent(noActiveUser.noActivityStudent, noActiveUser.realNameStudent)"
            :circleRadius="'80%'"
            :colorList="meterColorList"
          />
        </div>
        <div class="chart_name">图5 实名学生无活动占比</div>
        <h4 class="m-top150">2.2 近三年实名师生无活动情况</h4>
        <p>
          该资源库建设院校近三年无活动用户数{{ getUtils_Fun(threeYearUser.userNum) }}人，其中教师{{
            getUtils_Fun(threeYearUser.teacher)
          }}人，学生{{ getUtils_Fun(threeYearUser.student) }}人。具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="threeYearUser.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="chart_name">图6 近三年无活动情况</div>
      </div>
      <div class="chart_box page-box">
        <h4>2.3 近三年建设院校新增实名学生无活动情况</h4>
        <p>
          该资源库建设院校近三年新增的已实名学生{{
            getUtils_Fun(threeYearRealStudent.student)
          }}人；其中实名无活动学生{{
            getUtils_Fun(threeYearRealStudent.NoActivityStudent)
          }}人。具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <meterChart
            :datas="
              getPercent(threeYearRealStudent.NoActivityStudent, threeYearRealStudent.student)
            "
            :circleRadius="'80%'"
            :colorList="meterColorList"
          />
        </div>
        <div class="chart_name">图7 近三年实名学生无活动占比</div>

        <div class="division m-top150">3. 资源无访问情况</div>
        <p>
          当前该资源库的素材资源总数{{ getUtils_Fun(resourceNoVisit.totalNum) }}条，无访问资源数{{
            getUtils_Fun(resourceNoVisit.noVisitTotalNum)
          }}条，无访问资源类型占比如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'lastcoursesMonthChart'"
            :datas="resourceNoVisit.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="chart_name">图8 无访问资源类型占比</div>

        <div class="division m-top150">4. 课程无访问情况</div>
        <p>
          当前该资源库的课程总数{{ getUtils_Fun(courseNoVisit.courseNum) }}门，无访问课程数{{
            getUtils_Fun(courseNoVisit.noVisitCourseNum)
          }}门，无访问课程类型分布具体如下图所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'lastcoursesMonthChart'"
            :datas="courseNoVisit.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="chart_name">图9 无访问课程类型分布</div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表
import meterChart from "@/components/chart/meterChart.vue"; //引入仪表图图表
import pageToPDF from "@/utils/htmlToPdf.js";

export default {
  components: { circularChart, vcolumnarChart, meterChart },
  data() {
    return {
      jd: null,
      completeNum: 0, //统计接口数量
      //柱状图或折线图的颜色
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ],
      meterColorList: ["#3B85FB", "#66cafe"],
      barColorList: ["#3B85FB", "#BBA8FF"],
      zykid: "", //资源库id，从路由参数获取
      analysisTime: "", //分析时间
      // 获取报告基本信息
      header: {},
      // 1.1 建设院校师生实名情况
      teacherStudent: {},
      // 1.2 近三年建设院校学生新增与实名情况
      threeYearStudent: {
        dataList: [],
        total: 0,
        realTotal: 0,
      },
      // 2.1 建设院校实名师生无活动情况 -无活动总体情况
      noActiveUser: {},
      // 2.2 近三年无活动情况
      threeYearUser: {
        dataList: [],
      },
      // 2.3 近三年建设院校新增实名学生无活动情况
      threeYearRealStudent: {},
      // 3. 素材资源无访问情况
      resourceNoVisit: {
        dataList: [],
      },
      // 4. 课程无访问情况
      courseNoVisit: {
        dataList: [],
      },
      loading: "", //是否导出加载中
    };
  },
  mounted() {
    if (this.$route.query) {
      this.jd = this.$route.query.jd;
      this.zykid = this.$route.query.zykid;
      this.dataChange(this.zykid);
      this.analysisTime = this.$route.query.time;
    }
    setTimeout(() => {
      this.getZykInformationVo(); // 获取报告基本信息
      this.getSchoolBuildRealNameStudentTeacher(); //1.1 建设院校师生实名情况
      this.getPastThreeYearBuildSchoolStudentCase(); // 1.2 近三年建设院校学生新增与实名情况
      this.getNoActivityOverallCase(); // 2.1 建设院校实名师生无活动情况 -无活动总体情况
      this.getPastThreeYearNoActivityCase(); // 2.2 近三年无活动情况
      this.getPastThreeYearBuildSchoolAddRealNameStudentCase(); // 2.3 近三年建设院校新增实名学生无活动情况
      this.getResourceNoVisitCase(); // 3. 素材资源无访问情况
      this.getNoVisitCourseCase(); // 4. 课程无访问情况
    }, 1000);
  },
  methods: {
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let name = this.header.zykName.split("(");
      let newName = "";
      let oldName = "";
      let zykName = "";
      if (name.length > 1) {
        newName = name[0];
        oldName = name[1].replace(")", "");
        zykName = `${newName}（原专业名称：${oldName}）`;
      } else zykName = this.header.zykName;
      pageToPDF(
        `${this.header.zykNum}_${zykName}_无活动数据分析${this.jd == 1 ? "季度" : ""}报告`,
        this.$refs.pdfContent,
        lableList
      );
    },

    // 切换专业
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            sessionStorage.setItem("zykId", e);
            this.reload();
          }
        });
    },

    //切换专业刷新视图层
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    // 获取占比
    getPercent(num1, num2) {
      return ((parseFloat(num1) / parseFloat(num2)) * 100).toFixed(2);
    },

    // 转化单位
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },

    // 获取报告基本信息
    getZykInformationVo() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let data = res.data;
            data.allHostUnit = data.allHostUnit.replaceAll(",", "，");
            this.header = data;
          }
        });
    },

    // 1.1 建设院校师生实名情况
    getSchoolBuildRealNameStudentTeacher() {
      this.$axios
        .post(this.$apiurls.getSchoolBuildRealNameStudentTeacher, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.teacherStudent = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.2 近三年建设院校学生新增与实名情况
    getPastThreeYearBuildSchoolStudentCase() {
      this.$axios
        .post(this.$apiurls.getPastThreeYearBuildSchoolStudentCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.threeYearStudent = data;
            this.threeYearStudent.dataList = [data.studentNum, data.realNameStudentNum];
            this.threeYearStudent.total = data.studentNum.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.threeYearStudent.realTotal = data.realNameStudentNum.reduce(function (a, b) {
              return a + b;
            }, 0);
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1 建设院校实名师生无活动情况 -无活动总体情况
    getNoActivityOverallCase() {
      this.$axios
        .post(this.$apiurls.getNoActivityOverallCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.noActiveUser = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2 近三年无活动情况
    getPastThreeYearNoActivityCase() {
      this.$axios
        .post(this.$apiurls.getPastThreeYearNoActivityCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.threeYearUser = res.data;
            this.threeYearUser.dataList = [
              {
                name: "学生",
                value: res.data.student,
              },
              {
                name: "教师",
                value: res.data.teacher,
              },
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3 近三年建设院校新增实名学生无活动情况
    getPastThreeYearBuildSchoolAddRealNameStudentCase() {
      this.$axios
        .post(this.$apiurls.getPastThreeYearBuildSchoolAddRealNameStudentCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.threeYearRealStudent = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 3. 素材资源无访问情况
    getResourceNoVisitCase() {
      this.$axios
        .post(this.$apiurls.getResourceNoVisitCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.noVisitResourceType;
            this.resourceNoVisit = res.data;
            this.resourceNoVisit.dataList = [
              {
                name: "视频类",
                value: data.video,
              },
              {
                name: "动画类",
                value: data.animation,
              },
              {
                name: "图形图像类",
                value: data.graphicImage,
              },
              {
                name: "虚拟仿真类",
                value: data.virtualSimulation,
              },
              {
                name: "文本类",
                value: data.text,
              },
              {
                name: "微课类",
                value: data.smallCourse,
              },
              {
                name: "音频类",
                value: data.audio,
              },
              {
                name: "ppt和富媒体等",
                value: data.ppt + data.courseWare + data.media,
              },
              {
                name: "其他",
                value: data.other,
              },
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 4. 课程无访问情况
    getNoVisitCourseCase() {
      this.$axios
        .post(this.$apiurls.getNoVisitCourseCase, this.zykid, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.courseNoVisit = data;
            this.courseNoVisit.dataList = [
              {
                name: "个性化课程",
                value: data.noVisitPersonalityNum,
              },
              {
                name: "标准化课程",
                value: data.noVisitStandardNum,
              },
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.export {
  position: absolute;
  right: 0.625rem;
  top: 0.625rem;
  z-index: 1;
}
.analysisReport {
  width: 100%;
  background: #fff;
  .analysisReport_box {
    // width: 85%;
    // margin: 0rem auto;
    // height: 8220px;
    .page-box {
      // padding: 7% 0;
      // height: 2740px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // border: 1px solid red;
      .header_titles {
        display: flex;
        justify-content: center;
        flex-flow: column;
        color: #000;
        text-align: center;
        position: relative;
        h1 {
          font-size: 45px;
          font-weight: bold;
          color: #1d244e;
        }

        .number_time {
          margin: 40px 0 60px 0;
          div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #707f9d;
            font-size: 1.5625rem;
          }
          p {
            width: 100%;
            height: 0.0625rem;
            background: #707f9d;
            margin-top: 0.5rem;
            &:last-child {
              opacity: 0.5;
              margin-top: 0.25rem;
            }
          }
        }
      }
      .division {
        position: relative;
        clear: both;
        text-align: center;
        font-weight: bold;
        font-size: 44px;
        color: #1d244e;
        margin-bottom: 30px;
      }
      h4 {
        font-weight: 700;
        font-size: 42px;
        color: #1d244e;
        line-height: 100px;
      }
      p {
        font-size: 35px;
        text-indent: 2em;
        line-height: 60px;
        color: #707f9d;
      }
      .echartsHeight {
        width: 80%;
        /* height: calc(100vw / 1080 * 300); */
        height: 28rem;
        margin: 0.625rem auto;
      }
      .chart_name {
        text-align: center;
        font-size: 30px;
        color: #707f9d;
      }
      .m-top150 {
        margin-top: 150px;
      }
      .biaoge {
        width: 95%;
        margin: 25px auto;
        .course {
          text-align: center;
          margin: 0px 10px;
          tr {
            height: 42px;
            color: #707f9d;
            font-size: 22px;
            &:nth-child(2n) {
              background: #fff;
              color: #566178;
            }
            &:nth-child(2n-1) {
              background: #7ed2ff;
              color: #566178;
            }
          }
        }
      }
    }
  }
}
</style>
